module.exports = __webpack_public_path__ + "img/Bloque_Icons.84b100d.svg";